import React, { useState } from 'react';
import useWindowSize from 'utils/hooks/useWindowSize';

const Disclamer = () => {
  const { width } = useWindowSize();

  const [isTextHide, setIsTextHide] = useState(true);

  return (
    <section className="disclamer">
      <div className="container">
        <div className="disclamer-title">Disclamer</div>
        <div className="disclamer-texts">
          <div className="disclamer-column">
            <p>
              DP World Trade Finance is a fintech platform (“the Platform”) owned by DP World Logistics FZE which brings
              together importers, exporters, and logistics companies from around the world (who seek trade finance)
              together with financial institutions and other providers of trade finance.{' '}
              {width <= 568 && isTextHide && (
                <span className="show-text" onClick={() => setIsTextHide(false)}>
                  More
                </span>
              )}
            </p>
            {(width > 568 || !isTextHide) && (
              <p>
                In order to access the Platform, you must confirm your jurisdiction. For UAE based persons (including
                the Dubai International Financial Centre (DIFC)), the Platform is operated by DP World Financial
                Services Limited. For those who are operating outside the United Arab Emirates, you will receive your
                services through the Platform operated by DP World Service Limited, and entity incorporated in Cayman
                Islands. {width <= 768 && <br />} DP World Financial Services Limited is an Authorized firm incorporated
                in the DIFC and regulated by the Dubai Financial Services Authority (DFSA). For persons outside the UAE,
                the Platform is operated by DP World Services Limited, an entity incorporated in the Cayman Islands. You
                will receive services and enter into an agreement with either DP World Financial Services Limited (DIFC)
                or DP World Services Limited (Cayman), subject to the jurisdiction you are located.
              </p>
            )}
          </div>
          {(width > 568 || !isTextHide) && (
            <div className="disclamer-column">
              <strong>DP World Financial Services Limited</strong>
              <p>
                DP World Financial Services Limited is incorporated in the Dubai International Financial Centre (DIFC)
                and is regulated by the Dubai Financial Services Authority (DFSA) to offer the financial services of
                ‘Arranging Credit’ and “Providing Credit” for client who is based in the UAE. These Financial Services
                are available through the Platform it operates. The Platform is operated by DP World Financial Services
                Limited whose registered office is at 811, Level 8, Burj Daman, DIFC, Al Moustaqbal Street, Dubai,
                United Arab Emirates.
              </p>
              <strong>DP World Services Limited</strong>
              <p>
                DP World Services Limited offers the service of ‘Arranging Credit’ to clients who are outside of the
                United Arab Emirates through its Platform. For any client who is interested to obtain the financial
                service of providing credit, you can submit your application on DP World Trade Finance. DP World
                Services Limited is incorporated in Cayman Island and is an exempted company with its registered office
                at c/o Walkers Corporate Limited, 190 Elgin Avenue, George Town, Grand Cayman Islands KY1-9008, Cayman
                Islands.{' '}
                {width <= 568 && !isTextHide && (
                  <span className="show-text" onClick={() => setIsTextHide(true)}>
                    Hide
                  </span>
                )}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Disclamer;
